import { render, staticRenderFns } from "./ShopCatalogsIndex.vue?vue&type=template&id=4078ca83&scoped=true"
import script from "./ShopCatalogsIndex.vue?vue&type=script&lang=js"
export * from "./ShopCatalogsIndex.vue?vue&type=script&lang=js"
import style0 from "./ShopCatalogsIndex.vue?vue&type=style&index=0&id=4078ca83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4078ca83",
  null
  
)

export default component.exports